angular.module('bmsApp.accounting')
	.controller('RecentPaymentModalCtrl', [
		'$scope',
		'$modalInstance',
		'$ngBootbox',
		'AccountingSvc',
		'customer',
		function ($scope,
							$modalInstance,
							$ngBootbox,
							AccountingSvc,
							customer) {

			function init() {
				$scope.loading = true;
				$scope.customer = customer;
				var params = {
					filter: {
						customer: $scope.customer.id,
					}
				}
				AccountingSvc.indexCustomerPayment(params)
					.then(function (response) {
						$scope.customerPayments = response.data.customer_payments;
						angular.forEach(response.data.customer_payments, function (customerPayment) {
							customerPayment.invoices = [];
							self.net_amount = 0.00;
							self.vat_amount = 0.00;
							self.gross_amount = 0.00;
							if ($scope.isSM()) {
								angular.forEach(customerPayment.sm_invoices, function (smInvoice) {
									smInvoice.net = smInvoice.net_amount;
									smInvoice.vat = smInvoice.vat_amount;
									smInvoice.gross = smInvoice.gross_amount;
									customerPayment.invoices.push(smInvoice);
								});
							}
							else if ($scope.isMM()) {
								angular.forEach(customerPayment.mm_invoices, function (mmInvoice) {
									customerPayment.invoices.push(mmInvoice);
								});
							}
							else if ($scope.isTG()) {
								angular.forEach(customerPayment.tg_invoices, function (tgInvoice) {
									angular.forEach(tgInvoice.parts, function (part) {
										self.net_amount += parseFloat(part.net_amount);
										self.vat_amount += parseFloat(part.vat_amount);
										self.gross_amount += parseFloat(part.gross_amount);
									});
									tgInvoice.net = self.net_amount;
									tgInvoice.vat = self.vat_amount;
									tgInvoice.gross = self.gross_amount;
									customerPayment.invoices.push(tgInvoice);
								});
							}
						});
						$scope.loading = false;
					});
			}

			function close() {
				$ngBootbox.confirm('Are you sure you want to do this?')
					.then(function () {
						$modalInstance.dismiss('cancel');
					});
			}

			var self = $scope.RecentPaymentModalCtrl = {
				loading: true,
				methods: {
					init: init,
					close: close
				}
			}
		}
	]);
